import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatErr } from "@/lib/api";
import { toast } from "sonner";
import SEOHead from "@/lib/seo/SEOHead";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatErr(err));
    } finally {
      setBusy(false);
    }
  };

  return <div className="min-h-screen flex items-center justify-center bg-white p-6">
    <SEOHead path="/forgot-password" title="Reset Password | RankTrust" />
    <div className="w-full max-w-md">
      <Link to="/" className="inline-block mb-8"><img src="/ranktrust-logo.png?v=5" alt="RankTrust" className="h-10 w-auto rounded-lg bg-[#0A1022] px-3 py-2"/></Link>
      <h1 className="text-3xl font-black text-zinc-900">Reset your password</h1>
      <p className="mt-3 text-zinc-600">Enter the email you use for RankTrust. We’ll send you a secure reset link.</p>
      {sent ? <div className="mt-6 rounded-xl border border-emerald-200 bg-emerald-50 p-4 text-emerald-800">If that email is registered, a reset link has been sent. Check your inbox and spam folder.</div> :
      <form onSubmit={submit} className="mt-6 space-y-4">
        <div><label className="label-tiny block mb-2">Email</label><input className="input-field" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} /></div>
        <button type="submit" className="btn-primary w-full justify-center" disabled={busy}>{busy ? <span className="spinner"></span> : "Send reset link"}</button>
      </form>}
      <div className="mt-6 text-sm"><Link to="/login" className="text-[#002FA7] font-semibold hover:underline">Back to sign in</Link></div>
    </div>
  </div>;
}
